import React, { useEffect, useRef } from 'react';

const NoteDisplay = ({ value }) => {
  const textareaRef = useRef(null);

  const resize = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  useEffect(() => {
    resize();
  }, [value]);

  return (
    <div className="flex items-stretch border border-gray-300 rounded bg-white min-w-0 overflow-hidden min-h-8">
      <span
        className="flex items-start justify-center w-8 shrink-0 text-gray-400 pt-2"
        aria-hidden="true"
      >
        <i className="fa-regular fa-note-sticky" />
      </span>
      <textarea
        ref={textareaRef}
        readOnly
        value={value || ''}
        placeholder="Note"
        className="flex-1 border-0 bg-transparent px-2 py-1.5 text-sm text-gray-900 resize-none overflow-hidden outline-none placeholder:text-gray-400"
        rows={1}
      />
    </div>
  );
};

export default NoteDisplay;
